// Dependencies
require("webstrap/type");

// Copy images
require("!!asset!./img/arrow.svg");

// Styles
require("./entete-1-1.scss");

// Javascript
var $ = require("jquery");

function GetIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0) {
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
    }
    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./)) {
        return 11;
    }
    else {
        return 0; //It is not IE
    }
}

// Scroll on click (arrow)
$('.entete-1-1').each(function () {

    var $elm = $(this),
        $btn = $('.entete-1-1__arrow-btn', $elm),
        $anchor = $($btn.attr('href'));

    $btn.on('click', function (e) {
        e.preventDefault();

        var offset = $anchor.offset(),
            menuHeight = 0,
            winHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            scrollPos = 0,
            $menu = $('.js-menu-1-1-top');

        if ($menu.length > 0) {
            menuHeight = $menu.height();
        }

        if (offset.top < winHeight) {
            scrollPos = offset.top;
        } else {
            scrollPos = offset.top - menuHeight;
        }

        $('html,body').animate({ scrollTop: scrollPos }, 750);
        return false;
    });
    
    if (GetIEVersion() > 0) {
        $("#homeVideo").remove();
    } else {
        try {
            document.getElementById('homeVideo').play();
        } catch (err) {
            console.log(err);
        }
    }

    

});


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/entete-1/view-1/index.js
// module id = 182
// module chunks = 0